import { FunctionComponent } from "react";

export const MobilityConceptLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/mobility-concept.jpeg"
      className={"w-32 md:w-[161px] h-4 md:h-5"}
      alt="Mobility Concept Logo"
    />
  );
};
